import { gql } from 'apollo-angular';

const UPDATE_SUBSTATUS = gql`
  mutation upsertSubstatus($id: ID, $input: ProjectSubstatusInput!) {
    upsertProjectSubstatus(input: $input, id: $id) {
      id
      project_status_id
      substatus_id
      subsequence_id
    }
  }
`;
const UPDATE_SUBSTATUS_DATE = gql`
  mutation upsertProjectSubstatusDate(
    $id: ID
    $input: ProjectSubstatusDateInput!
  ) {
    upsertProjectSubstatusDate(input: $input, id: $id) {
      id
      date
      utc_time
      timezone
      project_status_id
      target
      subsequence_id
      substatus_id
    }
  }
`;
const DELETE_SUBSTATUS_DATE = gql`
  mutation deleteProjectSubstatusDate($id: ID!) {
    deleteProjectSubstatusDate(id: $id) {
      id
    }
  }
`;

const UPDATE_WAREHOUSE_DATES = gql`
    mutation updateProjectCreditWarehouseLine($id: ID!, $warehouse_funding_deadline_time: String!, $warehouse_funding_deadline_date: Date!, $warehouse_funding_deadline_timezone: String!){
      updateProjectCreditWarehouseLine(
        id: $id,
        warehouse_funding_deadline_time: $warehouse_funding_deadline_time,
        warehouse_funding_deadline_date: $warehouse_funding_deadline_date,
        warehouse_funding_deadline_timezone: $warehouse_funding_deadline_timezone
      ){
        id
      }
    }
`
const GET_SUBSTATUS_DATES = gql`
  query getSubstatusDates($project_status_id: ID!) {
    projectSubstatusDates(project_status_id: $project_status_id) {
      id
      project_status_id
      subsequence_id
      substatus_id
      date
      target
    }
  }
`;
export {
  UPDATE_SUBSTATUS,
  UPDATE_SUBSTATUS_DATE,
  UPDATE_WAREHOUSE_DATES,
  DELETE_SUBSTATUS_DATE,
  GET_SUBSTATUS_DATES,
};
